import store from '@/store/store';

const freedomFigureMixin = {
    computed: {
        helpTitle() {
            return store.state[this.namespace].helpTitle;
        },

        helpText() {
            return store.state[this.namespace].helpText;
        },

        requiredClients() {
            return this.calculateRequiredClients(
                this.freedomFigure.target_income,
                this.freedomFigure.package_price
            );
        },

        monthlyCalls() {
            return this.calculateMonthlyCalls(
                this.requiredClients,
                this.freedomFigure.close_percentage,
            );
        },

        postData() {
            return {
                'target_income': this.freedomFigure.target_income,
                'close_percentage': this.freedomFigure.close_percentage,
                'package_price': this.freedomFigure.package_price
            };
        },
    },

    data() {
        return {
            freedomFigure: [],
            monthlyNumbers: [],
            ffItems: [],
            mnItems: [],

            rules: {
                'isNumber': value => {
                    const pattern = /^\d+$/;
                    return pattern.test(value) || 'Field must contain only numerals.';
                }
            },

            ffHeaders: [
                {
                    text: 'Target Income',
                    value: 'target_income',
                    align: 'center',
                    width: '20%'
                },
                {
                    text: 'Package Price',
                    value: 'package_price',
                    align: 'center',
                    width: '20%'
                },
                {
                    text: 'Required Clients',
                    value: 'required_clients',
                    align: 'center',
                    width: '20%'
                },
                {
                    text: 'Close %',
                    value: 'close_percentage',
                    align: 'center',
                    width: '20%'
                },
                {
                    text: 'Monthly Calls',
                    value: 'monthly_calls',
                    align: 'center',
                    width: '20%'
                }
            ],

            mnHeaders: [
                {
                    text: 'Month',
                    value: 'month',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Visits',
                    value: 'visits',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Booked',
                    value: 'booked_calls',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Conv %',
                    value: 'booked_visits',
                    align: 'center',
                    width: '12.5%'
                },

                {
                    text: 'Held',
                    value: 'held_calls',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Conv %',
                    value: 'held_booked',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Closed',
                    value: 'closed_calls',
                    align: 'center',
                    width: '12.5%'
                },
                {
                    text: 'Conv %',
                    value: 'closed_held',
                    align: 'center',
                    width: '12.5%'
                }
            ],

            months: [
                { value: 0, text: 'Select Month' },
                { value: 1, text: 'JAN' },
                { value: 2, text: 'FEB' },
                { value: 3, text: 'MAR' },
                { value: 4, text: 'APR' },
                { value: 5, text: 'MAY' },
                { value: 6, text: 'JUN' },
                { value: 7, text: 'JUL' },
                { value: 8, text: 'AUG' },
                { value: 9, text: 'SEP' },
                { value: 10, text: 'OCT' },
                { value: 11, text: 'NOV' },
                { value: 12, text: 'DEC' }
            ]
        };
    },

    methods: {
        formatNumber(number) {
            const options = {
                notation: 'standard',
            };

            return new Intl.NumberFormat('en-US', options).format(number);
        },

        formatDollar(number) {
            const options = {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            };

            return new Intl.NumberFormat('en-US', options).format(number);
        },

        formatConversionPercentage(int1, int2) {
            if (int1 > 0 && int2 > 0) {
                return this.formatNumber(
                    this.calculateConversionPercentage(int1, int2)
                ) + '%';
            }
            return '';
        },

        round(value) {
            return Number(Math.ceil(value));
        },

        divideTwoNumbers(divide, by)
        {
            if (divide > 0 &&
                by > 0
            ) {
                const divided = divide / by;
                return Math.ceil(divided);
            }

            return 0;
        },

        calculateMonthlyCalls(requiredClients, closePercentage) {
            const closePercent = closePercentage / 100;
            const division = this.divideTwoNumbers(requiredClients, closePercent);
            return this.divideTwoNumbers(division, 12);
        },

        calculateRequiredClients(targetIncome, packagePrice) {
            return this.divideTwoNumbers(targetIncome, packagePrice);
        },

        calculateConversionPercentage(int1, int2) {
            const getDecimal = Math.ceil((int1/int2) * 100);
            return (getDecimal);
        },

        // Required for initial month display.
        translateMonth($int) {
            switch ($int) {
            case 0:
                return '';
            case 1:
                return 'JAN';
            case 2:
                return 'FEB';
            case 3:
                return 'MAR';
            case 4:
                return 'APR';
            case 5:
                return 'MAY';
            case 6:
                return 'JUN';
            case 7:
                return 'JUL';
            case 8:
                return 'AUG';
            case 9:
                return 'SEP';
            case 10:
                return 'OCT';
            case 11:
                return 'NOV';
            case 12:
                return 'DEC';
            default:
                return '';
            }
        }
    }
};

export default freedomFigureMixin;
